module.exports = __webpack_public_path__ + "static/img/活动图-03.b5a2f07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/活动图-03.png
// module id = Fkjj
// module chunks = 16